import { FilePayloadFactoryFunctionType } from 'src/views/Forms/Components/InputFilesGroup/types'
import { CP_URL_BASE } from './url_constants'

export const STATEMENTS_FORMATS_MAP: { [key: string]: string } = {
  Pdf: 'pdf',
  Excel: 'xlsx',
  Csv: 'zip',
}

export const MIME_TYPE: { [key: string]: string } = {
  pdf: 'application/pdf',
  xlsx: 'application/vnd.ms-excel',
  csv: 'text/csv',
  xml: 'text/xml',
  zip: 'application/x-zip-compressed',
  html: 'text/html'
}

export const getFileName = (response: Response) => {
  const contentDisposition = response?.headers?.get('content-disposition')
  const hasSpacesGetFileName = contentDisposition?.includes('*=utf-8\'\'') && contentDisposition.split('*=utf-8\'\'')
  if(hasSpacesGetFileName?.[0]) {
    return hasSpacesGetFileName[1]
  }
  return response?.headers?.get('content-disposition')?.split('filename')?.[1].split('"')?.[1]
}

// eslint-disable-next-line
export const download = (data: any, fileName: string) => {
  const newBlob = new Blob([data])
  const blobUrl = window.URL.createObjectURL(newBlob)

  const link = document.createElement('a')
  link.href = blobUrl
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.parentNode.removeChild(link)

  window.URL.revokeObjectURL(blobUrl)
}

export const openPdfBlobInNewTab = (data: BlobPart) => {
  const blob = new Blob([data], { type: 'application/pdf' })
  const url = window.URL.createObjectURL(blob)
  window.open(url, '_blank', 'noopener,noreferrer')
  window.setTimeout(() => window.URL.revokeObjectURL(url), 120_000)
}

export const openFileNewTab = async (documentBase64: string) => {
  if(documentBase64) {
    const response = await fetch(documentBase64)
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    // @ts-ignore
    link.href = url
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
    window.URL.revokeObjectURL(url)
  }
}

export const toBase64 = (file: File) => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => resolve(reader.result)
  reader.onerror = error => reject(error)
})

// @ts-ignore:next-line
export const filePayloadFactory: FilePayloadFactoryFunctionType = async (file, step, name, applicationId, inputTextName, isSignature, downloadFileInfoID) => {
  if(isSignature) {
    return {
      applicationId,
      fileID: downloadFileInfoID,
      uploadFileName: file.name,
      uploadFileBase64: await toBase64(file)
    }
  }
  return {
    applicationId,
    documentID: 0,
    documentType: name,
    documentName: file.name,
    documentFileExtension: file.type,
    documentFileType: inputTextName || '', // format for declarations: type/id, example: director/123, ubo/123
    documentBase64: await toBase64(file),
    documentSection: step === '22' ? (parseInt(step) - 1).toString() : step, // step for declarations we use 21 for now
  }
}

export const roundNumbers = (num: number | string, decimal = 2): string => {
  if(!num || num === Infinity) {
    const zero = 0
    return zero.toFixed(decimal)
  }

  const local = Number((Math.round(Number(num) * 100) / 100)
    .toFixed(0))
    // @ts-ignore:next-line
    .toLocaleString('en-US')
  const decimalString = (Math.round(Number(num) * 100) / 100)
    .toFixed(decimal)
    .split('.')?.[1]

  return `${local}${decimal === 0 ? '' : '.'}${decimalString || ''}`
}

// @ts-ignore:next-line
export const formatNumbersToLocale = value => {
  if(!value) return '0'
  return new Intl.NumberFormat(navigator?.language || 'en-GB', { minimumFractionDigits: value?.toString()?.split('.')[1]?.length || 0 }).format(value)
}

export const roundDownAndFormat = (value: number, decimals: number): string => {
  const factor = Math.pow(10, decimals)
  const roundedValue = Math.floor(value * factor) / factor
  return new Intl.NumberFormat(navigator?.language || 'en-GB', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(roundedValue)
}

export const checkObjectValuesSomeExist = (obj: Record<string, boolean | string | number | null | undefined>) => Object.values(obj).some(value => value)

export const getIndexFromOptions = ({
  originOptions,
  searchTarget,
  fieldTarget
}: {
    originOptions: Record<string, string | boolean>[],
    searchTarget: string | boolean,
    fieldTarget?: string
  }) => {
  const index = originOptions?.findIndex(item => item?.[`${fieldTarget || 'label'}`] === searchTarget)
  return index === -1 ? null : index
}

// @ts-ignore:next-line
export const checkIfObject = obj => obj && !Array.isArray(obj) && typeof obj === 'object'

export const getDashboardUrl = ({url, equityGroup, mockUrl}: {url: string, equityGroup: string, mockUrl?: string}): string => {
  return import.meta.env.MODE !== 'development'
    ? `${CP_URL_BASE}${url}/${equityGroup}`
    : `${window.location.origin}/mock/${mockUrl}.json`
}

export const  randomizeNumbersInObjects = (array: Record<string, string | number>[]) => {
  return array.map(obj => {
    const newObj = { ...obj }
    Object.keys(newObj).forEach(key => {
      // @ts-ignore:next-line
      newObj[`${key}`] = typeof newObj[`${key}`] === 'number' ? newObj[`${key}`] * Math.random() * 3 : newObj[`${key}`]
    })

    return newObj
  })
}
